import { render, staticRenderFns } from "./differences.vue?vue&type=template&id=77a52af2"
import script from "./differences.vue?vue&type=script&lang=js"
export * from "./differences.vue?vue&type=script&lang=js"
import style0 from "./differences.vue?vue&type=style&index=0&id=77a52af2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports